import {createAction, handleActions} from 'redux-actions';
import _ from 'lodash';

//- Modal types
export const MODAL_NEW_STAFF_MEMBER = "MODAL_NEW_STAFF_MEMBER";
export const MODAL_REMOVE_STAFF_MEMBER = "MODAL_REMOVE_STAFF_MEMBER";
export const MODAL_REMOVE_ALIAS = "MODAL_REMOVE_ALIAS";
export const MODAL_ADD_ALIAS = "MODAL_ADD_ALIAS";
export const MODAL_CREATE_ORG_PRICE = 'MODAL_CREATE_ORG_PRICE';
export const MODAL_CHANGE_ORG_BALANCE = 'MODAL_CHANGE_ORG_BALANCE';
export const MODAL_ADD_ACCREDITATION_GROUP = 'MODAL_ADD_ACCREDITATION_GROUP';
export const MODAL_EDIT_ACCREDITATION_GROUP = 'MODAL_EDIT_ACCREDITATION_GROUP';
export const MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP = 'MODAL_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP';
export const MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP = 'MODAL_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP';
export const MODAL_REMOVE_ACCREDITATION_GROUP = 'MODAL_REMOVE_ACCREDITATION_GROUP';
export const MODAL_ADD_DEPARTMENT = 'MODAL_ADD_DEPARTMENT';
export const MODAL_EDIT_DEPARTMENT = 'MODAL_EDIT_DEPARTMENT';
export const MODAL_ADD_EMPLOYEE_TO_DEPARTMENT = 'MODAL_ADD_EMPLOYEE_TO_DEPARTMENT';
export const MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT = 'MODAL_REMOVE_EMPLOYEE_FROM_DEPARTMENT';
export const MODAL_REMOVE_DEPARTMENT = 'MODAL_REMOVE_DEPARTMENT';
export const MODAL_RESENT_ACTIVATION_STAFF_MEMBER = 'MODAL_RESENT_ACTIVATION_STAFF_MEMBER';
export const MODAL_CHANGE_ANCHOR = 'MODAL_CHANGE_ANCHOR';
export const MODAL_RESENT_ACTIVATION_ANCHOR = 'MODAL_RESENT_ACTIVATION_ANCHOR';
export const MODAL_REGISTER_APPLICANT = 'MODAL_REGISTER_APPLICANT';
export const MODAL_REMOVE_ACCREDITATION = 'MODAL_REMOVE_ACCREDITATION';
export const MODAL_REMOVE_BULK = 'MODAL_REMOVE_BULK';
export const MODAL_LICENSE_AGREEMENT = 'MODAL_LICENSE_AGREEMENT';
export const MODAL_VALIDATE_ACCREDITATION = 'MODAL_VALIDATE_ACCREDITATION';
export const MODAL_CERTIFIED_ACCREDITATION = 'MODAL_CERTIFIED_ACCREDITATION';
export const MODAL_VALIDATE_PENDING_ACCREDITATION = 'MODAL_VALIDATE_PENDING_ACCREDITATION';
export const MODAL_DISCARD_PENDING_ACCREDITATION = 'MODAL_DISCARD_PENDING_ACCREDITATION';
export const MODAL_REGISTER_ORG_BY_ANCHOR = 'MODAL_REGISTER_ORG_BY_ANCHOR';
export const MODAL_REMOVE_ACTIVE_CONSENT = 'MODAL_REMOVE_ACTIVE_CONSENT';
export const MODAL_CANCEL_CONSENT_REQUEST = 'MODAL_CANCEL_CONSENT_REQUEST';
export const MODAL_REMOVE_PRIOR_CONSENT = 'MODAL_REMOVE_PRIOR_CONSENT';
export const MODAL_DISMISS_CONSENT_REQUEST = 'MODAL_DISMISS_CONSENT_REQUEST';
export const MODAL_CHANGE_2FA_ENABLING = 'MODAL_CHANGE_2FA_ENABLING';
export const MODAL_REMOVE_SELF_STUDY_BOOK = 'MODAL_REMOVE_PRIOR_CONSENT';
export const MODAL_REMOVE_BULK_CONSENT_REQUEST = 'MODAL_REMOVE_BULK_CONSENT_REQUEST';
export const MODAL_ADD_CERTIFICATE = 'MODAL_ADD_CERTIFICATE';
export const MODAL_REMOVE_CERTIFICATE = 'MODAL_REMOVE_CERTIFICATE';
export const MODAL_SIGNING_ACCREDITATIONS_PROGRESS = 'MODAL_SIGNING_ACCREDITATIONS_PROGRESS';
export const MODAL_REMOVE_ACCREDITATION_REQUEST = 'MODAL_SIGNING_ACCREDITATIONS_PROGRESS';
export const MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN = 'MODAL_REMOVE_ACCREDITATION_REQUESTS_BY_DOMAIN';
export const MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN = 'MODAL_EDIT_ACCREDITATION_REQUESTS_BY_DOMAIN';
export const MODAL_ACCREDITATION_REQUESTS_WARNING = 'MODAL_ACCREDITATION_REQUESTS_WARNING';
export const MODAL_ACCREDITATION_REQUESTS_REJECT = 'MODAL_ACCREDITATION_REQUESTS_REJECT';
export const MODAL_ACCREDITATION_REQUESTS_SET_AG = 'MODAL_ACCREDITATION_REQUESTS_SET_AG';
export const MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR = 'MODAL_ACCREDITATION_REQUESTS_GET_ORG_ERROR';
export const MODAL_ACCREDITATION_REQUEST_DATA = 'MODAL_ACCREDITATION_REQUEST_DATA';
export const MODAL_VALIDATE_ACCREDITATION_REQUESTS_BY_DOMAIN = 'MODAL_VALIDATE_ACCREDITATION_REQUESTS_BY_DOMAIN';
export const MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN = 'MODAL_LAST_REQUESTORS_ACCREDITATION_REQUEST_BY_DOMAIN';
export const MODAL_ADD_ORG_FIRST_CERTIFICATE = 'MODAL_ADD_ORG_FIRST_CERTIFICATE';
export const MODAL_REMOVE_ASSISTANT = 'MODAL_REMOVE_ASSISTANT';
export const MODAL_REMOVE_BUSINESS_AMBASSADOR = 'MODAL_REMOVE_BUSINESS_AMBASSADOR';
export const MODAL_REMOVE_COMMISSION = 'MODAL_REMOVE_COMMISSION';
export const MODAL_BA_WIRE_DATA = 'MODAL_BA_WIRE_DATA';
export const MODAL_UNI_WIRE_DATA = 'MODAL_UNI_WIRE_DATA';
export const MODAL_COMPANIES_CREDITS_CONTACT_DATA = 'MODAL_COMPANIES_CREDITS_CONTACT_DATA';
export const MODAL_BA_DUE_PAYMENT_CONFIRM = 'MODAL_BA_DUE_PAYMENT_CONFIRM';
export const MODAL_UNI_DUE_PAYMENT_CONFIRM = 'MODAL_UNI_DUE_PAYMENT_CONFIRM';
export const MODAL_SYSTEM_DUE_PAYMENT_CONFIRM = 'MODAL_SYSTEM_DUE_PAYMENT_CONFIRM';
export const MODAL_VALIDATE_PENDING_ORGANIZATION = 'MODAL_VALIDATE_PENDING_ORGANIZATION';
export const MODAL_EDIT_ASSISTANT = 'MODAL_EDIT_ASSISTANT';
export const MODAL_PAYMENT_HISTORY_COMMENT = 'MODAL_PAYMENT_HISTORY_COMMENT';
export const MODAL_REMOVE_ORG = 'MODAL_REMOVE_ORG';
export const MODAL_VALIDATE_DOMAIN = 'MODAL_VALIDATE_DOMAIN';
export const MODAL_EDIT_VALIDATED_DOMAIN = 'MODAL_EDIT_VALIDATED_DOMAIN';
export const MODAL_REMOVE_VALIDATED_DOMAIN = 'MODAL_REMOVE_VALIDATED_DOMAIN';
export const MODAL_ADD_VALIDATED_DOMAIN = 'MODAL_ADD_VALIDATED_DOMAIN';
export const MODAL_APPLICANT_REQUESTS = 'MODAL_APPLICANT_REQUESTS';
export const MODAL_REMOVE_CERTIFIED_ACCREDITATION = 'MODAL_REMOVE_CERTIFIED_ACCREDITATION';
export const MODAL_COMPANY_CREDITS_HISTORY_MODAL = 'MODAL_COMPANY_CREDITS_HISTORY_MODAL';

//- Actions
export const showModal = createAction('MODAL_SHOW', modal => modal);

export const hideModal = () => (dispatch, getState) => {
    let activeModal = getActiveModal(getState());
    if (!_.isEqual(activeModal, initialState)) {
        dispatch({type: 'MODAL_HIDE'});
    }
};

//- State
export const initialState = {};

//- Reducers
export default handleActions({

    MODAL_SHOW: (state, action) => ({...action.payload}),

    MODAL_HIDE: () => initialState

}, initialState);

//- Selectors
export const getActiveModal = (state) => state.activeModal;



// WEBPACK FOOTER //
// ./src/reducers/common/activeModal.js